import styled from 'styled-components';

export const ContainerForm = styled.div`
    margin: 0px 20px;
`